"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The EVA SDK provides functional access to the back-end API services.
 * To start using the SDK you must call the initialise method at least once and provide the following:
 * - Your authentication token
 * - Your application id
 * - The EVA endpoint URL to use
 *
 * This information should have been provided to you by your EVA platform provider
 *
 * @preferred
 */
var settings_1 = require("./settings");
// Polyfill promise support
// This will update the global Promise implementation as needed
//
require("es6-promise/auto");
/**
 * This method makes the EVA SDK ready for use and configures access to your back-end datastore
 * @param  {string}     authenticationToken   Your application authentication token
 * @param  {number}     applicationId         The application identifier for your store
 * @param  {string}     endPointURL           The URL for the EVA back-end store you want to use
 * @return {void}                             This method doesn't return anything
 */
function init(authenticationToken, applicationId, endPointURL) {
    if (endPointURL === void 0) { endPointURL = "https://eva.newblack.io"; }
    settings_1.SettingsManager.setSiteAuthenticationToken(authenticationToken);
    settings_1.SettingsManager.setApplicationId(applicationId);
    settings_1.SettingsManager.setEndPointURL(endPointURL);
}
exports.init = init;
/**
 * Expose the settings manager and the means to override the XMLHttpRequest provider
 */
var settings_2 = require("./settings");
exports.settings = settings_2.SettingsManager;
var xhr_1 = require("./xhr");
exports.setTransportProvider = xhr_1.setTransportProvider;
exports.XHR = xhr_1.XHR;
var service_1 = require("./service");
exports.EVAService = service_1.EVAService;
/**
 * These are the data providers availabe in eva
 */
var applications_1 = require("./data/applications");
exports.Application = applications_1.Application;
var brands_1 = require("./data/brands");
exports.Brands = brands_1.Brands;
exports.searchBrands = brands_1.searchBrands;
var discounts_1 = require("./data/discounts");
exports.Discounts = discounts_1.Discounts;
var document_signing_1 = require("./data/document-signing");
exports.DocumentSigning = document_signing_1.DocumentSigning;
var user_1 = require("./data/user");
exports.LoggedInUser = user_1.LoggedInUser;
exports.users = user_1.Users;
exports.User = user_1.User;
var orders_1 = require("./data/orders");
exports.Order = orders_1.Order;
exports.SearchOrderList = orders_1.SearchOrderList;
exports.CustomerOrderList = orders_1.CustomerOrderList;
exports.OrdersWithReferenceList = orders_1.OrdersWithReferenceList;
exports.SuspendedOrderList = orders_1.SuspendedOrderList;
var shopping_cart_1 = require("./data/shopping-cart");
exports.ShoppingCart = shopping_cart_1.ShoppingCart;
var products_1 = require("./data/products");
exports.products = products_1.products;
var products_2 = require("./data/products");
exports.Product = products_2.Product;
exports.ProductList = products_2.ProductList;
var shops_1 = require("./data/shops");
exports.Shop = shops_1.Shop;
exports.ShopList = shops_1.ShopList;
exports.ShopProximityList = shops_1.ShopProximityList;
var suggestions_1 = require("./data/suggestions");
exports.SuggestionList = suggestions_1.SuggestionList;
var postnl_1 = require("./data/postnl");
exports.PostNL = postnl_1.PostNL;
// export { Rituals                                            } from "./data/rituals";
var fth_1 = require("./data/fth");
exports.FTH = fth_1.FTH;
// MakeUp
//
var make_up_1 = require("./data/make-up");
exports.MakeUp = make_up_1.MakeUp;
exports.MakeupListBlocks = make_up_1.MakeupListBlocks;
exports.MakeupListMenus = make_up_1.MakeupListMenus;
exports.MakeupListBlockVersions = make_up_1.MakeupListBlockVersions;
exports.MakeupListPageVersions = make_up_1.MakeupListPageVersions;
var blob_1 = require("./data/blob");
exports.Blob = blob_1.Blob;
var barcodes_1 = require("./data/barcodes");
exports.Barcodes = barcodes_1.Barcodes;
var addresses_1 = require("./data/addresses");
exports.AddressBook = addresses_1.AddressBook;
exports.addresses = addresses_1.Addresses;
var user_phone_numbers_1 = require("./data/user-phone-numbers");
exports.UserPhoneNumbers = user_phone_numbers_1.UserPhoneNumbers;
// export { Newsletter as newsletter                           } from "./data/newsletter";
var infrastructure_1 = require("./data/infrastructure");
exports.Station = infrastructure_1.Station;
exports.StationList = infrastructure_1.StationList;
var cultures_1 = require("./data/cultures");
exports.Cultures = cultures_1.Cultures;
var currencies_1 = require("./data/currencies");
exports.Currencies = currencies_1.Currencies;
var availability_1 = require("./data/availability");
exports.Availability = availability_1.Availability;
var functionalities_1 = require("./data/functionalities");
exports.Functionalities = functionalities_1.Functionalities;
var notification_1 = require("./data/notification");
exports.addPushNotificationDevice = notification_1.addPushNotificationDevice;
var notification_2 = require("./data/notification");
exports.removePushNotificationDevice = notification_2.removePushNotificationDevice;
var webshop_1 = require("./data/webshop");
exports.Webshop = webshop_1.Webshop;
exports.WebShopList = webshop_1.WebShopList;
var wishlist_1 = require("./data/wishlist");
exports.Wishlist = wishlist_1.Wishlist;
// export { Paazl                                              } from "./data/paazl";
var giftwrap_1 = require("./data/giftwrap");
exports.Giftwrap = giftwrap_1.Giftwrap;
var url_rewrite_1 = require("./data/url-rewrite");
exports.UrlRewrite = url_rewrite_1.UrlRewrite;
